/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowRoundTimeBackIcon16Light } from './ArrowRoundTimeBackIcon16Light';
import { ArrowRoundTimeBackIcon16Regular } from './ArrowRoundTimeBackIcon16Regular';
import { ArrowRoundTimeBackIcon16Solid } from './ArrowRoundTimeBackIcon16Solid';
import { ArrowRoundTimeBackIcon20Light } from './ArrowRoundTimeBackIcon20Light';
import { ArrowRoundTimeBackIcon20Regular } from './ArrowRoundTimeBackIcon20Regular';
import { ArrowRoundTimeBackIcon20Solid } from './ArrowRoundTimeBackIcon20Solid';
import { ArrowRoundTimeBackIcon24Regular } from './ArrowRoundTimeBackIcon24Regular';
import { ArrowRoundTimeBackIcon24Solid } from './ArrowRoundTimeBackIcon24Solid';
import { ArrowRoundTimeBackIcon32Regular } from './ArrowRoundTimeBackIcon32Regular';
import { ArrowRoundTimeBackIcon64Regular } from './ArrowRoundTimeBackIcon64Regular';
var sizes = {
    16: {
        light: ArrowRoundTimeBackIcon16Light,
        regular: ArrowRoundTimeBackIcon16Regular,
        solid: ArrowRoundTimeBackIcon16Solid,
    },
    20: {
        light: ArrowRoundTimeBackIcon20Light,
        regular: ArrowRoundTimeBackIcon20Regular,
        solid: ArrowRoundTimeBackIcon20Solid,
    },
    24: {
        regular: ArrowRoundTimeBackIcon24Regular,
        solid: ArrowRoundTimeBackIcon24Solid,
    },
    32: {
        regular: ArrowRoundTimeBackIcon32Regular,
    },
    64: {
        regular: ArrowRoundTimeBackIcon64Regular,
    },
};
export var ArrowRoundTimeBackIcon = forwardRef('ArrowRoundTimeBackIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
